import React from 'react';
import PropTypes from 'prop-types';
import logo from './img/logo_vivo.png';

// IMPORTS DE ESTILOS E IMAGENES:
import './style.scss';

const App = ({routes}) => (
  <div className="app">
    <img className="image_logo" src={logo} alt="Vivo" />
    <main>
      {routes}
    </main>
  </div>
);

App.propTypes = {
  routes: PropTypes.object.isRequired
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js